import { BrowserRouter, Routes, Route } from "react-router-dom";
import GlobalStyle from "./style/globalStyle";
import ApproveMarketing from "./pages/approveMarketing/approveMarketing";
import PrivacyPolicy from "./pages/privacyPolicy/privacyPolicy";
import TermsOfService from "./pages/termsOfService/termsOfService";

function App() {
  return (
    <BrowserRouter>
      <GlobalStyle />
      <Routes>
        <Route path="/" element={<TermsOfService />} />
        <Route path="/marketing" element={<ApproveMarketing />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />

        <Route path="*" element={<TermsOfService />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
